module.exports = "/_next/static/resources/life1-b3134ec5d22256ee06afe1d18171effd.webp";